module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home-layout",
    class: {
      'page-home-layout_hidden': !_vm.visible
    }
  }, [_c('markup-wrapper', [_c('div', {
    staticClass: "top"
  }, [(_vm.$slots.presentation) ? _c('div', {
    staticClass: "presentation"
  }, [_vm._t("presentation")], 2) : _vm._e(), (_vm.$slots.search) ? _c('div', {
    staticClass: "form"
  }, [_vm._t("search")], 2) : _vm._e()]), (_vm.$slots.events) ? _c('div', [_vm._t("events")], 2) : _vm._e(), (_vm.$slots.socials || _vm.$slots.default) ? _c('div', {
    staticClass: "content"
  }, [(_vm.$slots.socials) ? _c('div', {
    staticClass: "socials"
  }, [_vm._t("socials")], 2) : _vm._e(), (_vm.$slots.default) ? _c('div', {
    staticClass: "text"
  }, [_vm._t("default")], 2) : _vm._e()]) : _vm._e(), (_vm.$slots.dashboard) ? _c('div', {
    staticClass: "dashBoardSlot"
  }, [_vm._t("dashboard")], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c099d1","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/home/Home.vue
// module id = 281952afe774f782d92e
// module chunks = 16